import { maxBy } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { notNullish } from '@paragon/utilities';

import {
  getLoadCasesForActiveComponentDesignSorted,
  getSelectedLoadCaseInfoForSelectedItem,
  LoadCaseWithCapacity,
} from './getLoadCasesForActiveComponentDesignSortedSelector';

const getMaxCsiOrJsi = (
  loadCases: ReadonlyArray<LoadCaseWithCapacity>,
  selector: (loadCase: LoadCaseWithCapacity) => number | undefined,
) => {
  const maxLoadCaseAndValue = maxBy(
    loadCases
      .map((loadCase) => {
        const csiOrJsi = selector(loadCase);
        return csiOrJsi != null ? { loadCase, csiOrJsi } : null;
      })
      .filter(notNullish),
    ({ csiOrJsi }) => csiOrJsi,
  );
  if (maxLoadCaseAndValue == null) return null;
  const { loadCase: maxLoadCase, csiOrJsi } = maxLoadCaseAndValue;
  return `${csiOrJsi.toFixed(2)} from Load Case ${maxLoadCase.index}`;
};

export const getMaxCsiForSingleSelectedItem = createSelector(getLoadCasesForActiveComponentDesignSorted, (loadCases) =>
  getMaxCsiOrJsi(loadCases, (loadCase) => loadCase.csi),
);

export const getMaxJsiForSingleSelectedItem = createSelector(getLoadCasesForActiveComponentDesignSorted, (loadCases) =>
  getMaxCsiOrJsi(loadCases, (loadCase) => loadCase.jsi),
);

export const getLoadCaseCsiForSingleSelectedItem = createSelector(
  getSelectedLoadCaseInfoForSelectedItem,
  (loadCase) =>
    loadCase &&
    loadCase.csi !== undefined && {
      csi: loadCase.csi,
      loadCaseIndex: loadCase.index,
    },
);
